import React from 'react'

// components
import {
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'

// helpers
import { capitalizeFirstLetter } from 'src/helpers/text-format'

const AppDetails = ({
  letterDetails,
}) => {
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Letter Number"
          className='mb-3'
          subtitle={letterDetails?.letter_number ? letterDetails?.letter_number : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Type"
          className='mb-3'
          subtitle={letterDetails?.letter_type ? letterDetails?.letter_type : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Month"
          className='mb-3'
          subtitle={letterDetails?.letter_month ? letterDetails?.letter_month : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Year"
          className='mb-3'
          subtitle={letterDetails?.letter_year ? letterDetails?.letter_year : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Letter Recipient"
          className='mb-3'
          subtitle={letterDetails?.letter_recipient ? capitalizeFirstLetter(letterDetails?.letter_recipient) : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Letter Notes"
          className='mb-3'
          subtitle={letterDetails?.letter_notes ? letterDetails?.letter_notes : '-'}
        />
      </CRow>
    </>
  )
}

export default AppDetails
